import { createContext, FC, PropsWithChildren, useContext, useState } from 'react';

export type HeaderContextType = {
  showSpacesSearch: boolean;
  setShowSpacesSearch: (show: boolean) => void;
};
export const HeaderContext = createContext<HeaderContextType>({
  showSpacesSearch: false,
  setShowSpacesSearch: () => {
    throw new Error('setShowSpacesSearch function not implemented');
  },
});

export const useHeaderContext = () => useContext(HeaderContext);

export const HeaderContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [showSpacesSearch, setShowSpacesSearch] = useState<boolean>(false);

  return <HeaderContext.Provider value={{
    setShowSpacesSearch,
    showSpacesSearch,
  }}>
    {children}
  </HeaderContext.Provider>;
};